import { render, staticRenderFns } from "./void-invoice.vue?vue&type=template&id=c70dddd8"
import script from "./void-invoice.vue?vue&type=script&lang=js"
export * from "./void-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports